import { connect } from 'react-redux';

import selectors from '../selectors';
import actions from '../actions';
import entryActions from '../entry-actions';
import EisenhowerQuadrantPicker from '../components/EisenhowerQuadrantPicker';

const mapStateToProps = (state) => ({
  pendingPicker: selectors.selectPendingQuadrantPicker(state),
});

// FAMILY-EXT: матрица Эйзенхауэра — onPick дёргает updateCard с выбранным
// квадрантом + сразу прячет picker. onCancel — только hide, без записи
// (карточка остаётся в своей старой зоне).
const mapDispatchToProps = (dispatch) => ({
  onPick: (cardId, quadrant) => {
    dispatch(entryActions.updateCard(cardId, { eisenhowerQuadrant: quadrant }));
    dispatch(actions.hideEisenhowerPicker());
  },
  onCancel: () => {
    dispatch(actions.hideEisenhowerPicker());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EisenhowerQuadrantPicker);
